<template>
  <div
      class="moment"
      :class="[
      moment.type === 'Moment'
        ? 'moment--type-wreck'
        : 'moment--type-event'
    ]"
      :tabindex="-1"
      @click="onClick"
      @keydown.enter="onClick"
      @keydown.space="onClick"
  >
    <div
        :class="[
        'timeline-icon',
        moment.type === 'Moment'
          ? 'timeline-icon--vrak-off'
          : 'timeline-icon--event-off'
      ]"
        :data-epochid="epochId"
    ></div>

    <div class="moment__container">
      <!-- Alltid rendera denna -->
      <div class="moment__image">
        <div
            v-if="moment.imageHtml"
            v-html="moment.imageHtml"
        ></div>
        <div v-else class="moment__no-image-container">
          <span class="moment__no-image-graphic"></span>
        </div>
      </div>

      <div class="moment__text">
        <div class="moment__text-top">
          <div class="moment__year">
            {{ moment.year }}
          </div>
          <div class="moment__title">
            {{ moment.title }}
          </div>
          <div class="moment__description">
            {{ moment.momentExcerpt }}
          </div>
        </div>

        <span class="moment__arrow"></span>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import type { ITimelineMapItem } from "../../interfaces/ITimelineMapItem";
import { useTimelineMapStore } from "@features/Pages/TimelineMapPage/_js/app/store/timelineMapStore";

const props = defineProps<{
  moment: ITimelineMapItem;
  epochId: number;
  translations: any;
}>();

const store = useTimelineMapStore();
const isMoment = computed(() => props.moment.type === "Moment");

function onClick() {
  if (isMoment.value) {
    store.onShowModal(props.moment);
  }
}
</script>
